import React from 'react';
import { withRouter } from 'react-router';
import './upgrade.scss';

class PaymentButton extends React.Component {
  render() {
    return(
      <div className="payment-btn">
        <button onClick={(e) => {
          e.preventDefault();
          this.props.updateURL('payment', {
              plan: this.props.selectedPlan.type,
              plan_id: this.props.selectedPlan.plan_id,
              promo: this.props.promoCode,
              amount: this.props.amount,
          });
        }} className="pure-button pay-btn">Continue to checkout</button>
      </div>
    )
  }
}

export default withRouter(PaymentButton);
